import { graphql, useStaticQuery } from 'gatsby';
import ConfirmationPayment from '../../components/organisms/confirmation-payment/confirmationPayment';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';
import '../../styles/index.scss';

const ConfirmacionPago = () => {
    const data = useStaticQuery(graphql`
        query GET_PAYMENT_CONFIRMATION_STATUS_CONTENT {
            allContentfulHome(
                filter: { titulo: { eq: "Home portal de servicios" } }
            ) {
                nodes {
                    estaActivoPagos
                }
            }
            allContentfulMetaInfo(
                filter: { titulo: { eq: "Meta información estado de pagos " } }
            ) {
                nodes {
                    metaTitulo
                    metaDescripcion
                    metaImagen {
                        file {
                            url
                        }
                    }
                    urlCanonical
                    noIndex
                }
            }
        }
    `);

    const metaData = data?.allContentfulMetaInfo?.nodes[0];
    const isActive = data?.allContentfulHome?.nodes[0]?.estaActivoPagos;
    return (
        <GeneralPageTemplate
            data={metaData}
            sideMenu={<></>}
            isActive={isActive}
        >
            <ConfirmationPayment />
        </GeneralPageTemplate>
    );
};

export default ConfirmacionPago;
